import React from 'react';
import '../../assets/styles/PriceCard.css';

const Check = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="tp-price-card__check">
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5821 5.54289C21.9726 5.93342 21.9726 6.56658 21.5821 6.95711L10.2526 18.2867C9.86452 18.6747 9.23627 18.6775 8.84475 18.293L2.29929 11.8644C1.90527 11.4774 1.89956 10.8443 2.28655 10.4503C2.67354 10.0562 3.30668 10.0505 3.70071 10.4375L9.53911 16.1717L20.1679 5.54289C20.5584 5.15237 21.1916 5.15237 21.5821 5.54289Z"
    />
  </svg>
);

const PriceCard = ({
  name,
  title,
  icon,
  meta,
  price,
  currency = '€',
  period,
  features = [],
  ctaText,
  onCta,
  ctaDisabled = false,
  featured = false,
  badge,
  className = '',
  ...props
}) => (
  <article
    className={`tp-price-card ${featured ? 'is-featured' : ''} ${className}`.trim()}
    {...props}
  >
    {featured && badge && <span className="tp-price-card__badge">{badge}</span>}

    {icon && <span className="tp-price-card__icon" aria-hidden="true">{icon}</span>}

    {name && <h3 className="tp-price-card__name">{name}</h3>}

    {title && <h3 className="tp-price-card__title">{title}</h3>}

    {price !== undefined && price !== null && (
      <p className="tp-price-card__price">
        <span className="tp-price-card__currency">{currency}</span>
        <span className="tp-price-card__amount">{price}</span>
        {period && <span className="tp-price-card__period">/ {period}</span>}
      </p>
    )}

    {meta && <p className="tp-price-card__meta">{meta}</p>}

    {features.length > 0 && (
      <ul className="tp-price-card__list">
        {features.map((feature) => (
          <li key={feature} className="tp-price-card__item">
            <Check />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    )}

    {ctaText && (
      <button type="button" className="tp-price-card__action" onClick={onCta} disabled={ctaDisabled}>
        {ctaText}
      </button>
    )}
  </article>
);

export default PriceCard;
export { PriceCard };
